var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.messages),function(message){return _c('chat-message',{attrs:{"id":message.id,"message":message}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }